// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkedin-post-preview-body__content[data-v-79afa200],.linkedin-post-preview-body__message[data-v-79afa200]{font-size:14px}.linkedin-post-preview-body__message[data-v-79afa200]{padding:0 15px 5px;color:#231f20}.linkedin-post-preview-body__content[data-v-79afa200]{padding:10px 15px;background:#eef3f7}.linkedin-post-preview-body__title[data-v-79afa200]{font-weight:700;word-break:break-word}", ""]);
// Exports
module.exports = exports;
